import {Component} from '@angular/core';
import {PoliciesComponent} from '../policies.component';

@Component({
  selector: 'policies-uk',
  templateUrl: './policies.uk.component.html',
  styleUrls: ['../policies.component.scss'],
})
export class PoliciesUKComponent extends PoliciesComponent {}
